import React from 'react';
import { createPortal } from 'react-dom';

export const MODAL_ROOT_ID = 'modal-root';

/** Mount every application overlay outside local panel stacking/overflow contexts. */
const ModalPortal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (typeof document === 'undefined') return null;
  const target = document.getElementById(MODAL_ROOT_ID) || document.body;
  return createPortal(children, target);
};

export default ModalPortal;
